import { render, staticRenderFns } from "./joinGroup.vue?vue&type=template&id=080fac41&scoped=true&"
import script from "./joinGroup.vue?vue&type=script&lang=js&"
export * from "./joinGroup.vue?vue&type=script&lang=js&"
import style0 from "./joinGroup.vue?vue&type=style&index=0&lang=css&"
import style1 from "./joinGroup.vue?vue&type=style&index=1&id=080fac41&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080fac41",
  null
  
)

export default component.exports